import {
  Icon,
  Stack,
  P,
  If,
  IconButton,
  IconName,
  Clickable,
} from '@fashionnovateam/nova-ui-toolkit';
import { Link } from 'react-router-dom';
import React from 'react';
import { useNavigation } from '../../Lib/Hooks/navigation';

export type HeaderProps = {
  children?: React.ReactNode;
  icon?: IconName;
  title: string;
  subTitle?: string;
  onCloseLink?: string;
  custom?: boolean;
  beforeTitleChildren?: React.ReactNode;
};

export function Header({
  title,
  subTitle,
  icon,
  children,
  onCloseLink,
  custom = false,
  beforeTitleChildren = undefined,
}: HeaderProps) {
  const { setIsCollapsed, isCollapsed } = useNavigation();
  return (
    <Stack
      direction="row"
      gap="md"
      content="center"
      align="center"
      className="bg-neutral-100 xl:bg-neutral-0 border-b nu-border-neutral-200 min-h-14 max-h-14 px-5 xl:px-6 sticky top-0 left-0 z-10 text-nowrap"
    >
      {isCollapsed && (
        <Clickable
          className="border border-transparent hover:border-neutral-300 rounded-md p-2"
          onClick={() => setIsCollapsed(false)}
        >
          <Icon.SidebarRightClose />
        </Clickable>
      )}
      {onCloseLink && (
        <Link data-testid="close-link" to={onCloseLink}>
          <IconButton
            icon={<Icon name="multiple-cross/multiple-cross-cancel-default" />}
            label="Close"
            color="secondary"
            size="sm"
          />
        </Link>
      )}
      {beforeTitleChildren}
      <Stack
        direction="row"
        gap="sm"
        align="center"
        width={custom ? 'fit' : undefined}
      >
        {icon && (
          <Icon
            name={icon}
            variant="solid"
            className={`text-primary-700 ${subTitle ? 'text-xsm' : 'text-lg'}`}
          />
        )}
        {onCloseLink ? (
          <Link to={onCloseLink}>
            <P
              size={subTitle ? 'xsm' : 'lg'}
              weight="medium"
              color="primary"
              className="whitespace-nowrap truncate hover:underline"
            >
              {title}
            </P>
          </Link>
        ) : (
          <P
            size={subTitle ? 'xsm' : 'lg'}
            weight="medium"
            color="primary"
            className="whitespace-nowrap truncate"
          >
            {title}
          </P>
        )}

        <If condition={subTitle}>
          <Icon
            name="chevron/chevron-right"
            className="text-base-disabled text-xsm"
          />
          <P
            size="xsm"
            weight="medium"
            color="primary"
            className="whitespace-nowrap truncate"
            data-testid="page-subtitle"
          >
            {subTitle}
          </P>
        </If>
      </Stack>
      <Stack direction="row" gap="sm" width={custom ? 'full' : 'none'}>
        {children}
      </Stack>
    </Stack>
  );
}
